import Route from '@ember/routing/route'

export default class ImportingRoute extends Route {
  buildRouteInfoMetadata() {
    return {
      hideFooter: true,
    }
  }
}
